/* global globalThis */
import { z } from 'zod';

export const CHECKOUT_EXPERIMENT_STORAGE_KEY = 'botspot:experiment:stripe-hosted-checkout-2026-08';
export const CHECKOUT_EXPERIMENT_QA_STORAGE_KEY = `${CHECKOUT_EXPERIMENT_STORAGE_KEY}:qa`;
export const CHECKOUT_EXPERIMENT_IDENTITY_RESET = 'botspot:checkout-experiment-identity-reset';
export const CHECKOUT_EXPERIMENT_FLAG = 'stripe-hosted-checkout-2026-08';

export const isProductionCheckoutHost = (hostname) =>
  hostname === 'botspot.trade' || hostname === 'www.botspot.trade';

// Keep the current identity authoritative even when browser storage rejects a
// write or deletion. Successful writes return ownership to shared localStorage.
const storageOverrides = new Map();

export const readCheckoutExperimentStorage = (key) => {
  if (storageOverrides.has(key)) return storageOverrides.get(key);
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};

export const writeCheckoutExperimentStorage = (key, value) => {
  storageOverrides.set(key, value);
  try {
    if (value === null) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, value);
    storageOverrides.delete(key);
  } catch {
    // In-memory identity remains usable without restoring stale persisted data.
  }
};

/** A logout creates a new person; a same-buyer identify does not. */
export const resetCheckoutExperimentIdentity = () => {
  if (!globalThis.window) return;
  writeCheckoutExperimentStorage(CHECKOUT_EXPERIMENT_STORAGE_KEY, null);
  writeCheckoutExperimentStorage(CHECKOUT_EXPERIMENT_QA_STORAGE_KEY, null);
  window.dispatchEvent(new Event(CHECKOUT_EXPERIMENT_IDENTITY_RESET));
};

const hasPrefix = (value, prefix) => {
  const parsed = z.string().safeParse(value);
  return parsed.success && parsed.data.startsWith(prefix);
};

/** QA uses the real assignment path without contributing production experiment events. */
export const excludeCheckoutExperimentEvent = (event, hostname) => {
  const properties = event.properties || {};
  const isCheckoutEvent =
    hasPrefix(event.event, 'checkout_experience_') ||
    event.event === 'CheckoutExperienceConverted' ||
    properties.$feature_flag === CHECKOUT_EXPERIMENT_FLAG ||
    properties.feature_flag === CHECKOUT_EXPERIMENT_FLAG ||
    properties.checkout_experience_feature_flag === CHECKOUT_EXPERIMENT_FLAG;
  if (!isCheckoutEvent) return false;
  return (
    !isProductionCheckoutHost(hostname) ||
    properties.is_test === true ||
    properties.checkout_experience_subject_id === 'preview' ||
    hasPrefix(properties.checkout_experience_subject_id, 'checkout_qa_') ||
    hasPrefix(properties.checkout_experience_assignment_id, 'assign_preview_')
  );
};
